import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BannerObserverDirective } from "./banner-observer.directive";


@NgModule({
  declarations: [BannerObserverDirective],
  imports: [
    CommonModule
  ],
  exports: [BannerObserverDirective]
})
export class BannerObserverModule { }
